export default {
  FEEDBACK_MGMT_LIST_REQUEST: 'APP/FEEDBACK_MGMT/FEEDBACK_MGMT_LIST_REQUEST',
  FEEDBACK_MGMT_LIST_SUCCESS: 'APP/FEEDBACK_MGMT/FEEDBACK_MGMT_LIST_SUCCESS',
  FEEDBACK_MGMT_LIST_ERROR: 'APP/FEEDBACK_MGMT/FEEDBACK_MGMT_LIST_ERROR',
};
